export default __webpack_public_path__ + "static/media/dumaguete.dd06a10c.jpg";